import React, { useEffect } from "react";
import { Route, Routes, useLocation } from "react-router-dom";
import "./App.scss";
import ReactGA from "react-ga4";

import { Header } from "./components";
import {
  Atm,
  Conciliation,
  Developers,
  Faqs,
  Home,
  NotFound,
  PaymentLinks,
  People,
  PressBand,
  Prices,
  Privacy,
  QuickTransfer,
  Returns,
  Terms,
  UseCases,
  DirectDebit,
  BusinessTransfer,
} from "./pages/";
import useAppContext from "./context/Context";
import es_CL from "./lang/es_CL.json";
import es_MX from "./lang/es_MX.json";
import { IntlProvider } from "react-intl";

const messages = {
  cl: es_CL,
  mx: es_MX,
};

function App() {
  ReactGA.initialize("G-FVEWCH1KNE");

  const { activeCountry } = useAppContext();
  const appRef = React.createRef(null);
  const [fixed, setFixed] = React.useState(false);

  const location = useLocation();

  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  let botonChat;
  useEffect(() => {
    setTimeout(() => {
      botonChat = document.getElementById("fc_frame");
      if (activeCountry === "mx" && botonChat) {
        botonChat.style.display = "none";
      } else if (activeCountry === "cl" && botonChat) {
        botonChat.style.visibility = "visible";
        botonChat.style.display = "block";
      }
    }, 1000);
  }, []);

  useEffect(() => {
    botonChat = document.getElementById("fc_frame");
    if (activeCountry === "mx" && botonChat) {
      botonChat.style.display = "none";
    } else if (activeCountry === "cl" && botonChat) {
      botonChat.style.visibility = "visible";
      botonChat.style.display = "block";
    }
  }, [activeCountry, botonChat]);

  return (
    <IntlProvider locale={"en"} messages={messages[activeCountry]}>
      <div className="App" ref={appRef}>
        <Header fixed={fixed} />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="prices" element={<Prices />} />
          <Route path="developers" element={<Developers />} />
          <Route path="quick-transfer" element={<QuickTransfer />} />
          <Route path="payment-links" element={<PaymentLinks />} />
          <Route path="conciliation" element={<Conciliation />} />
          <Route path="returns" element={<Returns />} />
          <Route path="terms-conditions" element={<Terms />} />
          <Route path="privacy-policy" element={<Privacy />} />
          {/* <Route path="cookies" element={<Cookies />} /> */}
          <Route path="people-office" element={<People />} />
          <Route path="press-brand" element={<PressBand />} />
          <Route path="uses-cases" element={<UseCases />} />
          <Route path="eatm" element={<Atm />} />
          <Route path="faqs" element={<Faqs />} />
          <Route path="direct-debit" element={<DirectDebit />} />
          <Route path="business-transfer" element={<BusinessTransfer />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </div>
    </IntlProvider>
  );
}

export default App;
